(() => {
  const SELECTOR = '[data-footer-accordion]';
  const MOBILE_QUERY = '(max-width: 749px)';
  const accordions = new Set();
  const mediaQuery = window.matchMedia(MOBILE_QUERY);

  const syncAccordions = () => {
    accordions.forEach((accordion) => {
      if (!document.body.contains(accordion)) {
        accordions.delete(accordion);
        return;
      }

      if (mediaQuery.matches) {
        if (!accordion.dataset.footerAccordionTouched) {
          accordion.removeAttribute('open');
        }
      } else {
        accordion.setAttribute('open', '');
        delete accordion.dataset.footerAccordionTouched;
      }
    });
  };

  const registerAccordion = (accordion) => {
    if (accordions.has(accordion)) return;
    const summary = accordion.querySelector('.footer-accordion__summary');

    if (summary) {
      summary.addEventListener('click', () => {
        if (mediaQuery.matches) {
          accordion.dataset.footerAccordionTouched = 'true';
        }
      });
    }

    accordions.add(accordion);
  };

  const initAccordions = (root) => {
    if (!root) return;
    const elements = root.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    elements.forEach(registerAccordion);
    syncAccordions();
  };

  mediaQuery.addEventListener('change', syncAccordions);
  document.addEventListener('shopify:section:load', (event) => initAccordions(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach((accordion) => accordions.delete(accordion));
  });

  const onReady = () => initAccordions(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

